/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {UserPromptTypes} from '../../components/prompts/constants';

export const TOGGLE_USER_PROMPT = 'TOGGLE_USER_PROMPT';

export interface UserPromptOptions {
  display?: boolean;
  message?: string;
  translateOption?: GenericObject
  actionLabel?: string;
  autoHide: boolean;
  autoHideDuration?: number;
  type: UserPromptTypes;
  partialSuccessState?: string | null;
  customDismissLabel?: string;
  onDismiss?: Function;
  onAction?: Function;
}

/**
 * @toggleUserPrompt
 *
 */
export const toggleUserPrompt = (options: UserPromptOptions | {} = {}) => ({
  type : TOGGLE_USER_PROMPT, options
});
